import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as SignatureResetSvg } from '../../assets/signature-reset.svg';

export const SignatureResetIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={SignatureResetSvg} {...props} />;
};
